// @ts-nocheck
//@ts-ignore CREDIT CHANGE TO RUN CHECK-TYPES SUCCESSFULLY
export const debounce = <FN extends (...a: any[]) => any>(fn: FN, ms = 0) => {
  let timeoutId: NodeJS.Timeout
  const pending = []
  return (...args: Parameters<FN>) => {
    clearTimeout(timeoutId)
    return new Promise((res, rej) => {
      timeoutId = setTimeout(() => {
        const currentPending = [...pending]
        pending.length = 0
        Promise.resolve(fn.apply(this, args)).then(
          data => {
            currentPending.forEach(({ resolve }) => resolve(data))
          },
          error => {
            currentPending.forEach(({ reject }) => reject(error))
          }
        )
      }, ms)
      pending.push({ resolve: res, reject: rej })
    })
  }
}
